module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"saleZone":"Restaurant sale zones"},"es":{"saleZone":"Zonas del restaurante"}}')
  delete Component.options._Ctor
}
